import { z } from 'zod';

// Split out of field.schema.ts when it passed its 500-line budget; re-exported
// from the same barrel, so every importer still says '@attendance/shared'.

// ============================================================
// E11 leave-on-behalf. A login-less camp worker can't self-submit leave, so the
// operator files a reason-coded leave request on their behalf from the tablet.
// It rides the same device-token rails as /events and lands as a PENDING
// LeaveRequest in the existing web leave-approval queue (mirroring field
// corrections). The action maps to a seeded LeaveType code:
//   SICK      -> LeaveType 'SICK'
//   ON_LEAVE  -> LeaveType 'ANNUAL' (paper/annual leave already arranged)
//   SENT_HOME -> LeaveType 'UNPAID' (sent home early, unpaid)
// Nothing fakes an ON_LEAVE rollup status: the day engine only marks ON_LEAVE
// once HR APPROVES the request, exactly like a web-submitted leave.
export const FieldLeaveActionSchema = z.enum(['SICK', 'ON_LEAVE', 'SENT_HOME']);
export type FieldLeaveAction = z.infer<typeof FieldLeaveActionSchema>;

export const FieldLeaveRequestSchema = z.object({
  uuid: z.string().min(8).max(64),
  workerCode: z.string().min(1).max(32),
  action: FieldLeaveActionSchema,
  ts: z.number().int().positive(), // the leave day (device wall-clock, unix millis)
  reason: z.string().min(3).max(2000),
  operatorCode: z.string().min(1).max(32),
});
export type FieldLeaveRequest = z.infer<typeof FieldLeaveRequestSchema>;

export const FieldLeaveRequestsRequestSchema = z.object({
  leaveRequests: z.array(FieldLeaveRequestSchema).min(1).max(100),
});
export type FieldLeaveRequestsRequest = z.infer<typeof FieldLeaveRequestsRequestSchema>;
